"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  GoogleOneTapLogin: () => GoogleOneTapLogin_default
});
module.exports = __toCommonJS(src_exports);

// src/GoogleOneTapLogin/index.tsx
var import_react = __toESM(require("react"));
function GoogleOneTapLogin({
  clientId,
  onSuccess,
  onError,
  isLoggedIn = false
}) {
  const loadGoogleOneTapScript = () => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  };
  const verifyToken = async (token) => {
    try {
      onSuccess(token);
    } catch (error) {
      onError();
      console.log(error, "ERROR");
    }
  };
  const oneTap = (googleClientId) => {
    const { google } = window;
    if (google && googleClientId && !isLoggedIn) {
      google.accounts.id.initialize({
        client_id: googleClientId,
        cancel_on_tap_outside: false,
        callback: async (response) => {
          verifyToken(response.credential);
        }
      });
      google.accounts.id.prompt((notification) => {
        if (notification.isDismissedMoment()) {
          console.log(
            "getDismissedReason ::",
            notification.getDismissedReason()
          );
        }
      });
    }
  };
  (0, import_react.useEffect)(() => {
    loadGoogleOneTapScript();
    const timeout = setTimeout(() => oneTap(clientId), 2e3);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return /* @__PURE__ */ import_react.default.createElement("div", null);
}
var GoogleOneTapLogin_default = GoogleOneTapLogin;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GoogleOneTapLogin
});
//# sourceMappingURL=index.js.map